import React from 'react';
import Overview from './tabs/Overview';
import AgentOverview from './tabs/AgentOverview';
import CourseManagement from './tabs/CourseManagement';
import UserManagement from './tabs/UserManagement';
import Payments from './tabs/Payments';
import CustomerSupport from './tabs/CustomerSupport';
import PrivacySecurity from './tabs/PrivacySecurity';
import AnalyticsReporting from './tabs/AnalyticsReporting';
import ApiIntegration from './tabs/ApiIntegration';
import MarketingPromotion from './tabs/MarketingPromotion';
import NotificationsAlerts from './tabs/NotificationsAlerts';
import ProfileSettings from './tabs/ProfileSettings';
import AccountSettings from './tabs/AccountSettings';
import AuditLog from './tabs/AuditLog';
import BannerManagement from './tabs/BannerManagement';
import PartnershipManagementPage from '../pages/partnership-management/PartnershipManagementPage';
import ResourcesManagementPage from '../pages/resources-management/ResourcesManagementPage';
import './TabContent.css';

const TabContent = ({ activeTab, onTabChange }) => {
  // Get user role to determine which overview to show
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const userRole = (user.role || 'admin').toLowerCase();

  const renderContent = () => {
    switch (activeTab) {
      case 'overview':
        // Show Agent Overview for agents, regular Overview for admins
        if (userRole === 'agent') {
          return <AgentOverview onTabChange={onTabChange} />;
        }
        return <Overview />;
      case 'course-management':
        return <CourseManagement />;
      case 'user-management':
        return <UserManagement />;
      case 'pricing-billing':
        return <Payments />;
      case 'analytics-reporting':
        return <AnalyticsReporting onTabChange={onTabChange} />;
      case 'customer-support':
        return <CustomerSupport />;
      case 'api-integration':
        return <ApiIntegration />;
      case 'marketing-promotions':
        return <MarketingPromotion />;
      case 'privacy-security':
        return <PrivacySecurity />;
      case 'notifications-alerts':
        return <NotificationsAlerts />;
      case 'profile-settings':
        return <ProfileSettings />;
      case 'account-settings':
        return <AccountSettings />;
      case 'audit-logs':
        console.log('Rendering AuditLog component');
        return <AuditLog />;
      case 'banner-management':
        return <BannerManagement />;
      case 'partnerships':
        return <PartnershipManagementPage />;
      case 'resources-management':
        return <ResourcesManagementPage />;
      default:
        return <Overview />;
    }
  };

  return (
    <>
      {renderContent()}
    </>
  );
};

export default TabContent; 